import { render, staticRenderFns } from "./ConversionTable.vue?vue&type=template&id=e6038ff6&scoped=true&"
import script from "./ConversionTable.vue?vue&type=script&lang=js&"
export * from "./ConversionTable.vue?vue&type=script&lang=js&"
import style0 from "./ConversionTable.vue?vue&type=style&index=0&id=e6038ff6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6038ff6",
  null
  
)

/* custom blocks */
import block0 from "./ConversionTable.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports